import React, { Component, lazy } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { NavLink } from "react-router-dom";
import {
    hybridPanelLink,
    agentPanelLink,
    LoginResponse,
    ChatPanelTypes,
    monitoringPanelLink,
    loggedInPanelLink,
    ContentModel,
} from "../../models/index";
// Styling
import "../../assets/scss/components/sidebar/sidemenu/sidemenu.scss";
import history from '../../app/history';
import SideMenu from "./sidemenuHelper";
import * as _ from "lodash";
import { utils } from "../../utils";
import { ProgressSpinner } from "primereact/progressspinner";
import { signalRChatService } from "../../services/SignalRChatService";
import { Ripple } from "primereact/ripple";
import { ContextMenu } from "primereact/contextmenu";
import { process } from "@progress/kendo-data-query";
import EventEmitter, { Events } from "../../services/eventemitter";
import { ResponseMessage } from "../../constants/ResponseMessages";
import { t } from "i18next";

const LazyTranscript = lazy(() => import("../../views/transcript/chatTranscript"));
const LazyTranscriptForForm = lazy(() => import("../../components/transcript/transcriptIndexForForm"));
const LazyResourcesPool = lazy(() => import("../../views/resourcesPool/index"));
const LazyViewReport = lazy(() => import("../../components/report/index"));
const LazyMainComponent = lazy(() => import("../../components/chat/MainComponent"));
const LazySingleTabComponent = lazy(() => import("../../components/SingleTabComponent"));
const LazyCannedPage = lazy(() => import("../../views/canned/canned"));
const LazyPersonalCannedPage = lazy(() => import("../../views/personalcanned/personalcanned"));
const LazyPushContentPage = lazy(() => import("../../views/pushcontent/pushcontent"));
const LazyIPBlock = lazy(() => import("./../../views/ip-block"));
const LazyDepartment = lazy(() => import("../../views/department/department"));
const LazyPersonalInformation = lazy(() => import("../../views/resourcesPool/personal-information"));
const LazyTrainedOn = lazy(() => import("../../views/resourcesPool/trained-on"));
const LazyTrainedOnAssign = lazy(() => import("../../views/resourcesPool/trained-on-assign"));
const LazyLoggedInResources = lazy(() => import("../../views/manager/manager"));
const LazyCompany = lazy(() => import("../../views/company"));
const LazySmtpEmail = lazy(() => import("../../views/SmtpEmailSetup/smtpEmail"));
const LazyOneStepAccount = lazy(() => import("../../views/OneStepAccount/account"));
const LazyService = lazy(() => import("../../views/service/index"));
const LazyWebsiteWiseResources = lazy(() => import("../../views/WebsiteWise/WebsiteWiseResources"));
const LazyMonitoringPanel = lazy(() => import("../../views/monitoringpanel/monitoringPanel"));
const LazyWgDashboard = lazy(() => import("../../components/wgDashboard/wgDashboard"));
const LazyAssignUser = lazy(() => import("../../views/assignUserTrainer/AssignUserToTrainer"))
const LazyAgent_Pcm = lazy(() => import("../../views/AgentPCM/AgentPcm"))
const LazyPCM_Approval = lazy(() => import("../../views/PcmApproval/PCMSApproval"))
const LazyPoint_System = lazy(() => import("../../views/Points_System/PointsSystem"))
const LazyTestingModule = lazy(() => import("../../views/testingModule/testingModule"))

const LazyWrong_Link_Exceptions = lazy(() => import("../../views/wrongLinkExceptions/wrongLinkExceptions"))
const LazyChat_Logs = lazy(() => import("../../views/ChatLogs/ChatLogs"))
const LazySignup_Flow = lazy(() => import("../../views/pages/SignUpScreens/index"))
const LazyRoles_Permission = lazy(() => import("../../views/RolesPermission/RolesandPermission"))
const LazyWebServiceStatus = lazy(() => import("../../views/WebsiteServicesStatus/WebsiteService"))
const LazyLicense_Info = lazy(() => import("../../views/licenseInfo/licenseInfo"))
const LazyCompanyAllowd_interface = lazy(() => import("../../views/CompanyAllowedInterface/CompnayAllowed"))
const LazyEmployeeCompany = lazy(() => import("../../views/employeeCompany/employeeCompany"))
const LazySurvey_QuestionScreen = lazy(() => import("../../views/surveyQuestions/SurveyQuestionScreen"))
const LazywebChat = lazy(() => import("../../views/loggedInResources/chat/chat"))
const LazyOffline_EmailException = lazy(() => import("../../views/OfflineEmail Exception/OfflineEmailException"))

const LazyOffline_Email = lazy(() => import("../../views/Offline Email/OfflineEmail"));
const LazyReportsMenu = lazy(() => import("../../views/WgReportSubMenu/Index"));
const LazyCustom_Schedule = lazy(() => import("../../views/CustomSchedule/CustomSchedule-table"));

const BotManagement = lazy(() => import("../../components/Bot Generator/BotManagement"));
const ParagraphWise = lazy(() => import("../../components/Bot Generator/ParagraphWise"));
const wgDashboard = lazy(() => import("../../components/wgDashboard/wgDashboard"));
const QuestionAnswers = lazy(() => import("../../components/Bot Generator/QuestionAnswers"));
const FlowBase = lazy(() => import("../../components/Bot Generator/FlowBase"));
const ClosedBot = lazy(() => import("../../components/Bot Generator/ClosedBot"));

const OldClosedBot = lazy(() => import("../../components/Bot Generator/OldClosedBot"));

const ChatCustomizer = lazy(() => import("../../components/Bot Generator/ChatCustomizer"));
const ConversationBase = lazy(() => import("../../components/Bot Generator/ConversationBot"));
const ConversationalBot = lazy(() => import("../../components/Bot Generator/ConversationalBot"));
const LazyAgentTimeline = lazy(() => import("../../views/AgentTimeLine/index"));
const LazyInvolve_Configurations = lazy(() => import("../../views/InvolveConfiguration/InvolveConfiguration"));
const LazyMasterQC = lazy(() => import("../../views/MasterQC/MasterQC"))
const LazyFormCreation = lazy(() => import("../../views/FormCreation/formTabs"))
const LazyCrmDepartment = lazy(() => import("../../views/crmDepartment/emailSetup"))
const LazyViewResource = lazy(() => import("../../views/ViewAllResources/ViewResources"))
export const OperatorPanelRoute = "/chat/:chatid";

//export const OperatorPanelRoute = "/chat";

interface SideMenuContentState {
    switch: boolean;
    linkCheck: boolean;
    showModal: boolean;
    alertMessageModal: boolean;
    path: string;
    nextPath: string;
    currentUser: LoginResponse | null | undefined;
    Loading: boolean;
    currentUrl: string;
}

interface props {
    toggleSidebarMenu: any;
}

interface Route {
    path: string;
    title: string;
    interfaceName: string;
    image: string | null;
    icon: JSX.Element | null;
    component: React.LazyExoticComponent<any>;
    componentProps: object;
    showInMenu: boolean;
    backgroundColor: string;
    color: string;
    dashboardIcon: string;
    heading: string;
    content: string;

}

export const routes = (): Route[] => {
    var UserData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
    const content: ContentModel = ResponseMessage.getEenvironmentWiseContent();

    var HybridScreenHeading = content.hybridPanel;
    var MonitoringPanelScreenHeading = content.MonitoringPanel;

    return [
        {
            title: t("Dashboard"),
            path: "/dashboard",
            image: null,
            icon: <i className="fa-light fa-home" />,
            interfaceName: "",
            component: LazyWgDashboard,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "",
            color: "",
            dashboardIcon: "",
            heading: "",
            content: "",

        },
        {
            title: t("Start Chatting.title"),
            path: OperatorPanelRoute,
            image: null,
            icon: <i className="fa-light fa-comment" />,
            interfaceName: "Operator Window",
            component: LazySingleTabComponent,
            componentProps: { ChatPanelType: ChatPanelTypes.OperaterPanel, component: LazyMainComponent, componentName: "Chat" },
            showInMenu: true,
            backgroundColor: "#e8effb",
            color: "#5c8ec5",
            dashboardIcon: "fa-light fa-comment",
            heading: t("Start Chatting.heading"),
            content: t("Start Chatting.content"),
        },
        {
            title: HybridScreenHeading,
            path: "/hybridChat",
            image: null,
            icon: <i className="fa-light fa-eye" />,
            // Hybrid Panel interface is customized on the bases of 3 different interfaces,
            //check login.tsx customizeInterfaces function  
            interfaceName: "Hybrid Panel",
            component: LazySingleTabComponent,
            componentProps: { ChatPanelType: ChatPanelTypes.HybridPanel, component: LazyMainComponent, componentName: "Chat" },
            showInMenu: true,
            backgroundColor: "#eaf7ec",
            color: "#46a752",
            dashboardIcon: "fa-light fa-eye",
            heading: HybridScreenHeading,
            content: content.hybridPanelDescription,
        },
        {
            title: content.ChatTranscript,
            path: "/transcript",
            image: null,
            icon: <i className="fa-light fa-file-text" />,
            interfaceName: "Chat Transcripts",
            component: LazyTranscript,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#eeeefc",
            color: "#6961df",
            dashboardIcon: "fa-light fa-file-text",
            heading: content.ChatTranscript,
            content: content.ChatTranscriptDescription,
        },

        {
            title: t("Resource Pool.title"),
            path: "/resourcesPool",
            image: null,
            icon: <i className="fa-light fa-user" />,
            interfaceName: "View All Resources",
            component: LazyResourcesPool,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#f4f7eb",
            color: "#93ac44",
            dashboardIcon: "fa-light fa-user",
            heading: t("Resource Pool.heading"),
            content: t("Resource Pool.content"),
        },
        {
            title: t("PersonalInformationComponent.heading"),
            path: "/resourcesPool/personal-information",
            image: null,
            icon: <i className="fa-light fa-link" />,
            interfaceName: "Add Resources",
            component: LazyPersonalInformation,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "",
            color: "",
            dashboardIcon: "",
            heading: "",
            content: "",
        },
        {
            title: t("IP Block.title"),
            path: "/ip-block",
            image: null,
            icon: <i className="fa-light fa-wifi" />,
            interfaceName: "IP Block",
            component: LazyIPBlock,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#5c8ec5",
            dashboardIcon: "fa-light fa-wifi",
            heading: t("IP Block.heading"),
            content: t("IP Block.content"),
        },
        // {
        //     title: t("Reports.title"),
        //     path: "/report",
        //     image: null,
        //     icon: <i className="fa-light fa-bar-chart" />,
        //     interfaceName: "Chat Reporting",
        //     component: LazyViewReport,
        //     componentProps: {},
        //     showInMenu: true,
        //     backgroundColor: "#fbfaef",
        //     color: "#46a752",
        //     dashboardIcon: "fa-light fa-bar-chart",
        //     heading: t("Reports.heading"),
        //     content: t("Reports.content"),
        // },
        {
            title: content.CannedResponses,
            path: "/canned",
            image: null,
            icon: <i className="fa-light fa-envelope" />,
            interfaceName: "Quick Responses",
            component: LazyCannedPage,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fdf6ec",
            color: "#e27a6b",
            dashboardIcon: "fa-light fa-envelope",
            heading: content.CannedResponses,
            content: content.CannedResponsesDescription,
        },
        {
            title: t("Logged In Resources.title"),
            path: "/logged-in-resources",
            image: null,
            icon: <i className="fa-light fa-users" />,
            interfaceName: "Logged In Resources",
            component: LazyLoggedInResources,
            componentProps: { ChatPanelType: ChatPanelTypes.LoggedInResourcesPanel, component: LazyLoggedInResources, componentName: "LoggedInResources" },
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-users",
            heading: t("Logged In Resources.heading"),
            content: t("Logged In Resources.content"),
        },
        {
            title: t("Companies.title"),
            path: "/company",
            image: null,
            icon: <i className="fa-light fa-building" />,
            interfaceName: "Add Company",
            component: LazyCompany,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-building",
            heading: t("Companies.heading"),
            content: t("Companies.content"),
        },
        {
            title: t("Transcripts Subscribers.title"),
            path: "/transcriptSubscribers",
            image: null,
            icon: <i className="fa-light fa-inbox" />,
            interfaceName: "Add Department",
            component: LazyDepartment,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#ffe9ee",
            color: "#c5798b",
            dashboardIcon: "fa-light fa-inbox",
            heading: t("Transcripts Subscribers.heading"),
            content: t("Transcripts Subscribers.content"),
        },
        {
            title: t("SMTP Setup Email.title"),
            path: "/smtpEmail",
            image: null,
            icon: <i className="fa-light fa-envelopes" />,
            interfaceName: "Email Setup",
            component: LazySmtpEmail,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-envelopes",
            heading: t("SMTP Setup Email.heading"),
            content: t("SMTP Setup Email.content"),
        },
        {
            title: t("One Step Account.title"),
            path: "/OneStepAccount",
            image: null,
            icon: <i className="fa-light fa-user-plus" />,
            interfaceName: "One Step Account",
            component: LazyOneStepAccount,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-user-plus",
            heading: t("One Step Account.heading"),
            content: t("One Step Account.content"),
        },
        {
            title: t("Service Schedule.title"),
            path: "/service-schedule",
            image: null,
            icon: <i className="fa-light fa-calendar" />,
            interfaceName: "Service Schedule",
            component: LazyService,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#ebf0fc",
            color: "#695fec",
            dashboardIcon: "fa-light fa-calendar",
            heading: t("Service Schedule.heading"),
            content: t("Service Schedule.content"),
        },
        {
            title: MonitoringPanelScreenHeading,
            path: "/monitoringPanel",
            image: null,
            icon: <i className="fa-light fa-desktop" />,
            interfaceName: "Monitoring Panel",
            component: LazySingleTabComponent,
            componentProps: { ChatPanelType: ChatPanelTypes.MonitoringPanel, component: LazyMainComponent, componentName: "Chat" },
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#c5798b",
            dashboardIcon: "fa-light fa-desktop",
            heading: MonitoringPanelScreenHeading,
            content: t("MonitoringPanel.content"),
        },
        {
            title: t("Trained on"),
            path: "/resourcesPool/trained-on",
            image: null,
            icon: <i className="fa-regular fa-link" />,
            interfaceName: "",
            component: LazyTrainedOn,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "",
            color: "",
            dashboardIcon: "",
            heading: "",
            content: "",
        },
        {
            title: t("Trained on assign"),
            path: "/resources/trained-on-assign",
            image: null,
            icon: <i className="fa-regular fa-link" />,
            interfaceName: "",
            component: LazyTrainedOnAssign,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "",
            color: "",
            dashboardIcon: "",
            heading: "",
            content: "",
        },
        {
            title: t("Website wise Resources.title"),
            path: "/website-wise-resources",
            image: null,
            icon: <i className="fa-light fa-globe" />,
            interfaceName: "View All Websites Resources",
            component: LazyWebsiteWiseResources,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#c5798b",
            dashboardIcon: "fa-light fa-globe",
            heading: t("Website wise Resources.heading"),
            content: t("Website wise Resources.content"),
        },
        {
            title: t("Assign Users to Trainee.title"),
            path: "/Assign-Users-to-Trainee",
            image: null,
            icon: <i className="fa-regular fa-people-arrows"></i>,
            interfaceName: "Assign users to Trainer",
            component: LazyAssignUser,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(207 175 17)",
            dashboardIcon: "fa-regular fa-people-arrows",
            heading: t("Assign Users to Trainee.heading"),
            content: t("Assign Users to Trainee.content"),
        },
        {
            title: t("PCMs Approval.title"),
            path: "/PCMs-Approval",
            image: null,
            icon: <i className="fa-light fa-user-check"></i>,
            interfaceName: "PCMs Approval",
            component: LazyPCM_Approval,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(34 151 49)",
            dashboardIcon: "fa-light fa-user-check",
            heading: t("PCMs Approval.heading"),
            content: t("PCMs Approval.content"),
        },
        {
            title: t("Agent's PCM.title"),
            path: "/Agent-PCM",
            image: null,
            icon: <i className="fa-light fa-list-ul"></i>,
            interfaceName: "Operator PCM",
            component: LazyAgent_Pcm,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(213 73 49)",
            dashboardIcon: "fa-light fa-list-ul",
            heading: t("Agent's PCM.heading"),
            content: t("Agent's PCM.content"),
        },
        {
            title: t("Points System.title"),
            path: "/Point-System",
            image: null,
            icon: <i className="fa-light fa-money-check-dollar"></i>,
            interfaceName: "Points System",
            component: LazyPoint_System,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(235 45 45)",
            dashboardIcon: "fa-light fa-money-check-dollar",
            heading: t("Points System.heading"),
            content: t("Points System.content"),
        },
        {
            title: t("wronglinkexception.title"),
            path: "/wrong-link-exceptions",
            image: null,
            icon: <i className="fa-light fa-link-slash"></i>,
            interfaceName: "Wrong Link Exceptions",
            component: LazyWrong_Link_Exceptions,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fdf6ec",
            color: "#e27a6b",
            dashboardIcon: "fa-light fa-link-slash",
            heading: t("wronglinkexception.title"),
            content: t("wronglinkexception.content"),
        },

        {
            title: t("Chat Logs.title"),
            path: "/Chat-Logs",
            image: null,
            icon: <i className="fa-light fa-memo-circle-check"></i>,
            interfaceName: "Chat Logs",
            component: LazyChat_Logs,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(240 94 0)",
            dashboardIcon: "fa-light fa-memo-circle-check",
            heading: t("Chat Logs.heading"),
            content: t("Chat Logs.heading"),
        },
        {
            title: t("License Information.title"),
            path: "/license-info",
            image: null,
            icon: <i className="fal fa-id-card"></i>,
            interfaceName: "FrmLicenseInfo",
            component: LazyLicense_Info,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(34 151 49)",
            dashboardIcon: "fal fa-id-card",
            heading: t("License Information.heading"),
            content: t("License Information.content"),
        },
        {
            title: t("Roles and Permissions.title"),
            path: "/Roles-Permission",
            image: null,
            icon: <i className="fa-light fa-ballot-check"></i>,
            interfaceName: "Roles and Permissions",
            component: LazyRoles_Permission,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(32 30 22)",
            dashboardIcon: "fa-light fa-ballot-check",
            heading: t("Roles and Permissions.heading"),
            content: t("Roles and Permissions.content")
        },
        {
            title: t("Website Service Status.title"),
            path: "/WebsiteService-Status",
            image: null,
            icon: <i className="fa-light fa-book-atlas"></i>,
            interfaceName: "Website Service Status",
            component: LazyWebServiceStatus,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(123 235 21)",
            dashboardIcon: "fa-light fa-book-atlas",
            heading: t("Website Service Status.heading"),
            content: t("Website Service Status.content"),
        },
        {
            title: t("Company Allowed Interfaces.title"),
            path: "/Company-Allowed-Interfaces",
            image: null,
            icon: <i className="fa-light fa-building-lock"></i>,
            interfaceName: "Company Allowed Interfaces",
            component: LazyCompanyAllowd_interface,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(105, 97, 223",
            dashboardIcon: "fa-light fa-building-lock",
            heading: t("Company Allowed Interfaces.heading"),
            content: t("Company Allowed Interfaces.content"),

        },
        {
            title: t("Survey.header"),
            path: "/Survey-Questions",
            image: null,
            icon: <i className="fa-light fa-newspaper"></i>,
            interfaceName: "Survey Questions",
            component: LazySurvey_QuestionScreen,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(105, 97, 223)",
            dashboardIcon: "fa-light fa-newspaper",
            heading: t("Survey.header"),
            content: t("Survey.content"),
        }, {
            title: t("OfflineEmailException.title"),
            path: "/Offline-Email-Exception",
            image: null,
            icon: <i className="fa-light fa-triangle-exclamation"></i>,
            interfaceName: "Offline Email Notification",
            component: LazyOffline_EmailException,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(234 13 47)",
            dashboardIcon: "fa-light fa-triangle-exclamation",
            heading: t("OfflineEmailException.title"),
            content: t("OfflineEmailException.content")
        },
        {
            title: t("Employee Company.title"),
            path: "/employee-company",
            image: null,
            icon: <i className="fa-light fa-building-user"></i>,
            interfaceName: "EmployeeCompanyForm",
            component: LazyEmployeeCompany,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "rgb(32 30 22)",
            dashboardIcon: "fa-light fa-building-user",
            heading: t("Employee Company.heading"),
            content: t("Employee Company.content"),
        },
        {
            title: t("One Step Account.Offline Email"),
            path: "/Offline-Email",
            image: null,
            icon: <i className="fa-light fa-envelope-circle-check"></i>,
            interfaceName: "Offline Email setup",
            component: LazyOffline_Email,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(40 84 28)",
            dashboardIcon: "fa-light fa-envelope-circle-check",
            heading: t("One Step Account.Offline Email"),
            content: t("OfflineEmail.content")
        },
        {
            title: t("Reports.title"),
            path: "/Dashboard-Reports",
            image: null,
            icon: <i className="fa-light fa-chart-area"></i>,
            interfaceName: "Dashboard Reports",
            component: LazyReportsMenu,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(237 237 248)",
            color: "rgb(22 45 177)",
            dashboardIcon: "fa-light fa-chart-area",
            heading: t("Reports.title"),
            content: t("DashboardReports.content"),
        },
        {
            title: t("DashboardReports.title"),
            path: "/Dashboard-Reports/:NestedRoute",
            image: null,
            icon: <i className="fa-solid fa-chart-area"></i>,
            interfaceName: "Dashboard Reports",
            component: LazyReportsMenu,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(40 84 28)",
            dashboardIcon: "fa-solid fa-chart-area",
            heading: t("DashboardReports.title"),
            content: t("DashboardReports.content")
        },
        {
            title: t("DashboardReports.title"),
            path: "/Dashboard-Reports/:NestedRoute/:Tab",
            image: null,
            icon: <i className="fa-solid fa-chart-area"></i>,
            interfaceName: "Dashboard Reports",
            component: LazyReportsMenu,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "rgb(238, 238, 252)",
            color: "rgb(40 84 28)",
            dashboardIcon: "fa-solid fa-chart-area",
            heading: t("DashboardReports.title"),
            content: t("DashboardReports.content")
        }, {
            title: t("testingModule.title"),
            path: "/testing-module",
            image: null,
            icon: <i className="fa-light fa-comment"></i>,
            interfaceName: "Testing Module",
            component: LazySingleTabComponent,
            componentProps: { ChatPanelType: ChatPanelTypes.TestingChatPanel, component: LazyTestingModule, componentName: "Chat" },
            showInMenu: true,
            backgroundColor: "#e8effb",
            color: "rgb(235 45 45)",
            dashboardIcon: "fa-light fa-comment",
            heading: t("testingModule.title"),
            content: t("testingModule.content"),
        },
        {
            title: t("Custom_Schedule.title"),
            path: "/custom-schedule",
            image: null,
            icon: <i className="fa-light fa-calendar-days"></i>,
            interfaceName: "Custom Schedule",
            component: LazyCustom_Schedule,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(228 229 231)",
            color: "rgb(53 37 118)",
            dashboardIcon: "fa-light fa-calendar-days",
            heading: t("Custom_Schedule.title"),
            content: t("Custom_Schedule.content"),
        },
        {
            title: "Bot Builder",
            path: "/bot",
            image: null,
            icon: <i className="fa-light fa-boxes-stacked" />,
            interfaceName: "Bot Builder",
            component: BotManagement,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-boxes-stacked",
            heading: "Bot Builder",
            content: "View & manage Chat Bots and stories",
        },
        {
            title: "Paragaph",
            path: "/paragraph",
            image: null,
            icon: <i className="far fa-paragraph" />,
            interfaceName: "",
            component: ParagraphWise,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "far fa-paragraph",
            heading: "Paragraph",
            content: "View Paragraph",
        },
        {
            title: "Question Answers",
            path: "/qna",
            image: null,
            icon: <i className="far fa-question-circle" />,
            interfaceName: "",
            component: QuestionAnswers,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "far fa-question-circle",
            heading: "QnA",
            content: "View QnA",
        },
        {
            title: "FlowBase",
            path: "/FlowBase",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: FlowBase,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "QnA",
            content: "View QnA",
        },
        {
            title: "ClosedBot",
            path: "/ClosedBot",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: ClosedBot,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "QnA",
            content: "View QnA",
        },
        {
            title: "OldClosedBot",
            path: "/OldClosedBot",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: OldClosedBot,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "QnA",
            content: "View QnA",
        },
        
        {
            title: "ConversationalBot",
            path: "/ConversationalBot",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: ConversationalBot,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "Conversation Bot",
            content: "ConversationalBot",
        },
        {
            title: "ConversationBase",
            path: "/ConversationBase",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: ConversationBase,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "Conversation Bot",
            content: "View QnA",
        },
        {
            title: "ChatCustomizer",
            path: "/ChatCustomizer",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "",
            component: ChatCustomizer,
            componentProps: {},
            showInMenu: false,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "Chat Customizer",
            content: "View QnA",
        },
        {
            title: t("agentTimeLine.title"),
            path: "/Agent-Time-Line",
            image: null,
            icon: <i className="fa-light fa-clock"></i>,
            interfaceName: "Operator Timeline",
            component: LazyAgentTimeline,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(228 229 231)",
            color: "#c5798b",
            dashboardIcon: "fa-light fa-clock",
            heading: t("agentTimeLine.title"),
            content: t("agentTimeLine.title"),
        },
        {
            title: t("involveConfiguration.title"),
            path: "/Involve-Configurations",
            image: null,
            icon: <i className="fa-light fa-lock"></i>,
            interfaceName: "Involve Configurations",
            component: LazyInvolve_Configurations,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "rgb(220 239 233)",
            color: "rgb(69 108 96)",
            dashboardIcon: "fa-light fa-lock",
            heading: t("involveConfiguration.title"),
            content: t("involveConfiguration.content"),
        },
        {
            title: t("Master-QC.title"),
            path: "/Master-QC",
            image: null,
            icon: <i className="fa-light fa-sitemap"></i>,
            interfaceName: "Master QC",
            component: LazySingleTabComponent,
            componentProps: { ChatPanelType: ChatPanelTypes.QcMasterPanel, component: LazyMainComponent, componentName: "Chat" },
            showInMenu: true,
            backgroundColor: "rgb(226 230 237)",
            color: "rgb(66 69 80)",
            dashboardIcon: "fa-light fa-sitemap",
            heading: t("Master-QC.title"),
            content: t("Master-QC.title"),
        },
        {
            title: "Chat Transcript for Form",
            path: "/transcriptforform",
            image: null,
            icon: <i className="fa-light fa-file-text" />,
            interfaceName: "CRM Setup",
            component: LazyTranscriptForForm,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#eeeefc",
            color: "#6961df",
            dashboardIcon: "fa-light fa-file-text",
            heading: "Chat Transcript for Form",
            content: content.ChatTranscriptDescription,
        },
        {
            title: "CRM Setup",
            path: "/form-creation",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "CRM Setup",
            component: LazyFormCreation,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "CRM Setup",
            content: "Create and manage dynamic forms",
        },
        {
            title: "Department Setup",
            path: "/email-setup",
            image: null,
            icon: <i className="fa-light fa-indent" />,
            interfaceName: "Department Setup",
            component: LazyCrmDepartment,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#b9ad42",
            dashboardIcon: "fa-light fa-indent",
            heading: "Department Setup",
            content: "Create and manage dynamic forms",
        },
        {
            title: t("View-All-Resources.title"),
            path: "/View-All-Resources",
            image: null,
            icon: <i className="fa-light fa-users-line" />,
            interfaceName: "View All Resources",
            component: LazyViewResource,
            componentProps: {},
            showInMenu: true,
            backgroundColor: "#fbfaef",
            color: "#c5798b",
            dashboardIcon: "fa-light fa-users-line",
            heading: t("View-All-Resources.title"),
            content: t("View-All-Resources.title"),
        },

    ];
}


class SideMenuContent extends Component<props, SideMenuContentState> {
    contextMenuItems: { label: any }[] = [
        {
            label: <span style={{ padding: "10px", }} onClick={(e) => this.openChildWindow(e)}>Open in new window</span>,
        }
    ];
    contextMenu: ContextMenu | null = null!;

    constructor(props) {
        super(props);

        this.state = {
            switch: false,
            linkCheck: false,
            showModal: false,
            path: "",
            nextPath: "",
            currentUser: JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse,
            Loading: false,
            currentUrl: '',
            alertMessageModal: false
        };
    }

    handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetPath: string) => {
        window?.myAPI?.hideCustomMenu(false);
        if (event.button === 1) {
            this.setState({ alertMessageModal: true })
            event.preventDefault(); // Prevent default behavior
            // Add your custom logic here if needed
            return;
        }
        else if (event.button === 0) {

            if (targetPath?.toString() === utils.getCurrentPathName()?.toString()) {
                event.preventDefault();
                return;
            }



            if (targetPath !== utils.getCurrentPathName()?.toString()) {
                event.preventDefault();
                if (utils.getCurrentPathName()?.toString() === hybridPanelLink ||
                    utils.getCurrentPathName()?.toString() === agentPanelLink || utils.getCurrentPathName()?.toString() === monitoringPanelLink) {
                    this.setState({ showModal: true, path: utils.getCurrentPathName(), nextPath: targetPath });
                }
                else {
                    history.push(targetPath);
                    if (utils.isElectronBuild()) {
                        window.location.reload();
                    }
                }
            }
        }
        else if (event.button === 2) {
            this.setState({ currentUrl: targetPath })
            this.contextMenu?.show(event)
        }

    };

    openContextMenu = (e, currentPath) => {
        this.setState({ currentUrl: currentPath })
        this.contextMenu?.show(e)
    }


    openChildWindow = (event) => {
        // if (event.button === 1) {

        var path = utils.getCurrentPathName();
        var currenturl = this.state.currentUrl;

        if (path == agentPanelLink && this.state.currentUrl == agentPanelLink) {
            currenturl = "false";
        }

        if (path == hybridPanelLink && this.state.currentUrl == hybridPanelLink) {
            currenturl = "false";
        }

        if (path == monitoringPanelLink && this.state.currentUrl == monitoringPanelLink) {
            currenturl = "false";
        }

        if (path == loggedInPanelLink && this.state.currentUrl == loggedInPanelLink) {
            currenturl = "false";
        }

        if (path == hybridPanelLink && this.state.currentUrl == agentPanelLink) {
            currenturl = "false";
        }

        if (path == hybridPanelLink && this.state.currentUrl == monitoringPanelLink) {
            currenturl = "false";
        }

        if (path == agentPanelLink && this.state.currentUrl == hybridPanelLink) {
            currenturl = "false";
        }

        if (path == agentPanelLink && this.state.currentUrl == monitoringPanelLink) {
            currenturl = "false";
        }

        if (path == monitoringPanelLink && this.state.currentUrl == hybridPanelLink) {
            currenturl = "false";
        }

        if (path == monitoringPanelLink && this.state.currentUrl == agentPanelLink) {
            currenturl = "false";
        }


        if ((this.state.currentUrl == hybridPanelLink ||
            this.state.currentUrl == agentPanelLink ||
            this.state.currentUrl == loggedInPanelLink ||
            this.state.currentUrl == monitoringPanelLink)) {

            if (path != agentPanelLink && path != hybridPanelLink && path != loggedInPanelLink && path != monitoringPanelLink) {
                currenturl = path;
                history.push(this.state.currentUrl)
                window.location.reload()
            }
        }
        if (utils.isElectronBuild()) {
            localStorage.setItem("childWindowURl", currenturl);
            window?.myAPI?.ChildWindowUrl(currenturl);
        }
        // window?.myAPI?.CHILD_WINDOW_URL(currenturl);
        // }
    }

    renderIcon(icon: JSX.Element) {
        return <span className="menu-icon">{icon}</span>;
    }

    getUserPermittedRoutes = () => {
        var filteredRoutes = routes()

        //.............remove report screen from left menu ,for other then liveadmins.
        if (!utils.isLiveAdminsCompany(this.state.currentUser?.userLoginData?.empCompId!)) {
            filteredRoutes = filteredRoutes?.filter(x => x.path != "/report")
        }

        return filteredRoutes.filter(
            (route) =>
                (route.interfaceName === "" && route.showInMenu === true) ||
                (route.showInMenu === true &&
                    _.some(this.state.currentUser?.interfaces, (item) => item.interfaceName.toLowerCase() === route.interfaceName.toLowerCase()))
        );
    };


    getCurrentPanelTitle = () => {
        const content: ContentModel = ResponseMessage.getEenvironmentWiseContent();

        let hybridPanelName = content.hybridPanel;
        let monitoringPanelName = content.MonitoringPanel;

        if (this.state.path === hybridPanelLink) {
            return t("alert-message.quitPanelMessage") + " " + hybridPanelName + "?"
        }
        else if (this.state.path === agentPanelLink) {
            return t("alert-message.quitPanelMessage") + " Start Chatting?"
        }
        else {
            return t("alert-message.quitPanelMessage") + " " + monitoringPanelName + "?"
        }
    }


    render() {
        return (
            <>
                <ContextMenu model={this.contextMenuItems} ref={(el) => (this.contextMenu = el)} />

                <SideMenu className="sidebar-content" toggleSidebarMenu={this.props.toggleSidebarMenu}>
                    {this.getUserPermittedRoutes().map((route) => {
                        if (utils.isElectronBuild()) {
                            return (
                                <SideMenu.MenuSingleItem key={route.path}>
                                    <NavLink
                                        title={route.title}
                                        // onClick={(event) => this.handleClick(event, route.path)}
                                        onMouseDown={(event) => this.handleClick(event, route.path)}
                                        to={route.path}
                                    // onContextMenu={(e) => this.openContextMenu(e, route.path)} aria-haspopup
                                    >
                                        {route.icon ? (
                                            this.renderIcon(route.icon)
                                        ) : (
                                            <img alt={route.title} src={(process as any).env.PUBLIC_URL + route.image} />
                                        )}
                                        <span className="menu-item-text">{route.title}</span>
                                    </NavLink>
                                </SideMenu.MenuSingleItem>
                            );
                        } else {
                            return (
                                <SideMenu.MenuSingleItem key={route.path}>
                                    <NavLink
                                        title={route.title}
                                        onClick={(event) => this.handleClick(event, route.path)}
                                        to={route.path}
                                    >
                                        {route.icon ? (
                                            this.renderIcon(route.icon)
                                        ) : (
                                            <img alt={route.title} src={(process as any).env.PUBLIC_URL + route.image} />
                                        )}
                                        <span className="menu-item-text">{route.title}</span>
                                    </NavLink>
                                </SideMenu.MenuSingleItem>
                            );
                        }
                    })}
                </SideMenu>


                <Modal isOpen={this.state.showModal}>
                    <ModalHeader>{t("alert-message.PanelChange")}</ModalHeader>
                    <ModalBody>
                        {this.getCurrentPanelTitle()}
                    </ModalBody>
                    <ModalFooter style={{ display: 'block' }}>
                        {!this.state.Loading ? (
                            <div style={{ float: 'right' }} >
                                <button
                                    className="wgbtn p-ripple"
                                    onClick={() => {
                                        EventEmitter.emit(Events.unMountingChatComponent, "")
                                        this.setState({ Loading: true })
                                        history.push(this.state.nextPath);
                                        signalRChatService.removeNotificationInfo()
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 1000);
                                    }}
                                >
                                    <Ripple />  {t("Yes")}
                                </button>
                                <button style={{ marginLeft: "8px" }} className="wgclear-btn p-ripple" onClick={() => this.setState({ showModal: false })}>
                                    <Ripple />   {t("No")}
                                </button >

                            </div >
                        ) : (

                            <div className="shiftPanel-spinner-div">
                                <ProgressSpinner
                                    style={{ height: "50px", width: "50px", backgroungColor: "red" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /></div>)
                        }
                    </ModalFooter>
                </Modal >



                <Modal isOpen={this.state.alertMessageModal}>
                    <ModalHeader>{t("alert-message.PanelChange")}</ModalHeader>
                    <ModalBody>
                        {t("alert-message.PanelChangeMessage")}

                    </ModalBody>
                    <ModalFooter style={{ display: 'block' }}>
                        <div style={{ float: 'right' }} >
                            <button style={{ marginLeft: "8px" }} className="wgclear-btn p-ripple" onClick={() => this.setState({ alertMessageModal: false })}>
                                <Ripple />   {t("wg-buttons.Cancel")}
                            </button >
                        </div >
                    </ModalFooter>
                </Modal >

            </>
        );
    }
}

export default SideMenuContent;
